<!-- Searches how to pages, admin pages, the linked guides, and every FAQ. -->
<div class="help-search" role="search" [class.page-layout]="layout === 'page'">
  <label class="screenreader" [attr.for]="inputId">Search the Help Center</label>
  <div class="help-search-field">
    <mat-icon [fontSet]="'material-icons-outlined'">search</mat-icon>
    <input
      #searchInput
      [id]="inputId"
      type="search"
      autocomplete="off"
      [placeholder]="placeholder"
      (input)="onSearchChange(searchInput.value)"
    />
    <button
      type="button"
      class="clear-search"
      *ngIf="isSearching"
      (click)="clearSearch()"
    >
      <span class="screenreader">Clear search</span>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="search-results" *ngIf="isSearching" [class.page-layout]="layout === 'page'">
  <div class="search-results-header">
    <p class="search-results-count" aria-live="polite">
      {{ searchResults.length }}
      {{ searchResults.length === 1 ? "result" : "results" }}
    </p>
    <button
      type="button"
      class="view-all-entries"
      *ngIf="hasMoreMatches"
      (click)="viewAllEntries()"
    >
      View all {{ totalMatches }} entries
    </button>
  </div>
  <!-- Grouped by section rather than labelling every row -->
  <div class="result-group" *ngFor="let group of searchGroups">
    <h4 class="result-group-heading">{{ group.heading }}</h4>
    <ul class="search-results-list">
      <li *ngFor="let result of group.results">
        <a
          *ngIf="!result.external"
          [routerLink]="result.href"
          (click)="clearSearch()"
        >
          {{ result.title }}
        </a>
        <a
          *ngIf="result.external"
          rel="noopener noreferrer"
          target="_blank"
          [href]="result.href"
          (click)="clearSearch()"
        >
          {{ result.title }}
        </a>
        <p class="result-snippet" *ngIf="result.snippet">
          {{ result.snippet }}
        </p>
      </li>
    </ul>
  </div>
  <p class="no-results" *ngIf="!searchResults.length">
    Nothing matched that search. Try a different word, or browse the topics
    below.
  </p>
</div>
